import { render, staticRenderFns } from "./CompanyERS.vue?vue&type=template&id=2fc9bc50&scoped=true"
import script from "./CompanyERS.vue?vue&type=script&lang=js"
export * from "./CompanyERS.vue?vue&type=script&lang=js"
import style0 from "./CompanyERS.vue?vue&type=style&index=0&id=2fc9bc50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9bc50",
  null
  
)

export default component.exports